import React from "react";
import LayoutDetailPage, {
  type LayoutDetailPageProps,
} from "@/pages/tech/layouts/LayoutView";

/**
 * PrintLayoutView — Canonical Delegation Wrapper (Rule 2 & ZIndexView compatibility).
 * Hợp nhất 100% hiển thị chi tiết bài bình về LayoutDetailPage (/layouts/$layoutId).
 */
export default function PrintLayoutView(props: LayoutDetailPageProps = {}) {
  return <LayoutDetailPage {...props} />;
}
